module.exports = __webpack_public_path__ + "static/media/Lucy-Forbes-Screenwriting-and-Directing.22e17315.jpg";